<template>
  <div class="Accordion_list">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'accordion-list',

    props: {
      expandFirstItem: {
        type: Boolean,
        default: true
      },

      recordAccordionId: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        expandAccordionId: null
      }
    },

    methods: {
      toggleAccordion (accordionId) {
        this.$children.forEach(item => {
          if (item.accordionId === accordionId) {
            if (item.showBody) {
              this.expandAccordionId = null
            } else {
              this.expandAccordionId = accordionId
            }
            item.showBody = !item.showBody
          } else {
            item.showBody = false
          }
        })
      },

      autoExpandFirstItem () {
        if (this.expandFirstItem && this.$children.length) {
          this.expandAccordionId = this.$children[0].id
          this.$children[0].showBody = true
        }
      }
    },

    mounted () {
      this.autoExpandFirstItem()
      this.$on('toggle-accordion', accordionId => {
        this.toggleAccordion(accordionId)
      })
    },

    watch: {
      expandAccordionId: function (newVal, oldVal) {
        if (this.recordAccordionId) {
          this.$emit('accordion-change', newVal)
        }
      }
    }
  }
</script>
